import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { newReturnCustomer: { getNewReturnCustomer } } = apiUrls;

export const GET_NEW_RETURN_CUSTOMER_SUCCESS = 'GET_NEW_RETURN_CUSTOMER_SUCCESS';
export const GET_NEW_RETURN_CUSTOMER_LOADING = 'GET_NEW_RETURN_CUSTOMER_LOADING';


export const getNewReturnCustomerData = ({ fromDate, toDate, vendor }) => async (dispatch) => {

    try {
        if (vendor) {
            const { url } = getNewReturnCustomer
            const requestData = {
                ...getNewReturnCustomer,
                url: url.replace('{{vendor}}', vendor).
                replace('{{fromDate}}', fromDate).replace('{{toDate}}', toDate)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: GET_NEW_RETURN_CUSTOMER_SUCCESS,
                data,
                vendor
            })
        }

    } catch (e) {

        dispatch({
            type: GET_NEW_RETURN_CUSTOMER_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },
            vendor
        })
    }
}

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: GET_NEW_RETURN_CUSTOMER_LOADING,
            isLoading,
            vendor
        });
    }
}